module.exports = __webpack_public_path__ + "img/iphone-hero.c04d6e19.webp";